// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__GaaDm","footer":"ReportModalFilter_footer__1hn2i"};